(function () {
  var MOBILE_MQ = '(max-width: 767px)';

  function initDiscountSlider(scope) {
    if (typeof jQuery === 'undefined' || !jQuery.fn.slick) return;

    var $ = jQuery;

    (scope ? $(scope) : $(document))
      .find('.product-discounts__slider')
      .each(function () {
        var $slider = $(this);

        if ($slider.hasClass('slick-initialized')) return;

        var isMobile = window.matchMedia(MOBILE_MQ).matches;

        var autoplay = isMobile
          ? $slider.data('autoplay-mobile') === true
          : $slider.data('autoplay-desktop') === true;

        var speed = parseInt(
          isMobile ? $slider.data('speed-mobile') : $slider.data('speed-desktop'),
          10
        ) || 5000;

        $slider.slick({
          dots: true,
          arrows: false,
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: true,
          autoplay: autoplay,
          autoplaySpeed: speed,
          pauseOnHover: true,
          pauseOnFocus: true,
          swipeToSlide: true,
          touchThreshold: 12
        });
      });
  }

  function reinitAll() {
    if (typeof jQuery === 'undefined' || !jQuery.fn.slick) return;
    jQuery('.product-discounts__slider.slick-initialized').slick('unslick');
    initDiscountSlider();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initDiscountSlider();
  });

  // Re-init when crossing the mobile/desktop breakpoint
  // (window resize, phone rotate, or customizer device toggle)
  var mql = window.matchMedia(MOBILE_MQ);
  if (mql.addEventListener) {
    mql.addEventListener('change', reinitAll);
  } else {
    mql.addListener(reinitAll); // older Safari
  }

  document.addEventListener('shopify:section:load', function (event) {
    initDiscountSlider(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (typeof jQuery !== 'undefined' && jQuery.fn.slick) {
      jQuery(event.target)
        .find('.product-discounts__slider.slick-initialized')
        .slick('unslick');
    }
  });

  // Merchant clicks a block in the editor: jump to it and pause autoplay
  document.addEventListener('shopify:block:select', function (event) {
    if (typeof jQuery === 'undefined' || !jQuery.fn.slick) return;

    var $slide  = jQuery(event.target).closest('.discount-slide');
    var $slider = $slide.closest('.product-discounts__slider');
    if (!$slider.hasClass('slick-initialized')) return;

    var index = $slider.find('.discount-slide').not('.slick-cloned').index($slide);
    $slider.slick('slickGoTo', index);
    $slider.slick('slickPause');
  });

  // Merchant deselects: resume autoplay
  document.addEventListener('shopify:block:deselect', function (event) {
    if (typeof jQuery === 'undefined' || !jQuery.fn.slick) return;

    jQuery(event.target)
      .closest('.product-discounts__slider')
      .slick('slickPlay');
  });
})();